import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useMarket } from '@/lib/market/market-context';
import { isMarket } from '@/lib/market/types';

/**
 * §10.1：market guard；設定 data-market。
 *
 * 「設定 data-market」這句話在 P0 是由 MarketProvider 的 effect 做的，而且文件
 * 特別寫了「**只會有這一個地方寫 dataset.market**——漲跌色寫死在結構上不可能，
 * 就是因為沒有第二個寫入點」。
 *
 * 所以這裡**不自己寫 dataset.market**，而是把路由參數同步進 MarketProvider。
 * 權威是 URL（可分享、可後退），單一寫入點仍然是 MarketProvider。
 * 在這裡多加一個 `document.documentElement.dataset.market = market`
 * 就是製造第二個寫入點，而兩個寫入點遲早會不同意。
 */
export const Route = createFileRoute('/$market')({
  beforeLoad: ({ params, search }) => {
    if (!isMarket(params.market)) {
      throw redirect({ to: '/$market/dashboard', params: { market: 'tw' }, search, replace: true });
    }
  },
  component: MarketLayout,
});

function MarketLayout() {
  const { market: param } = Route.useParams();
  const { market, setMarket } = useMarket();

  useEffect(() => {
    if (isMarket(param) && param !== market) setMarket(param);
  }, [param, market, setMarket]);

  return <Outlet />;
}
